import { ALL_BUTTON_POSITION_LIST, } from '@/common/manager/position/button-position';
// eslint-disable-next-line import/no-cycle
import { getBizComponent, getRunTimeBizComponent } from '@/common/util/util';
import './button.scss';
import { config as buttonGroupConfig } from './button-group/view';
import { config as formReloadConfig } from './form-reload/view';
import { config as formRerenderConfig } from './form-rerender/view';
import { config as setFormFieldStateConfig } from './set-form-field-state/view';
import { config as setFormValueConfig } from './set-form-value/view';
import { config as linkConfig } from './link/view';
import { config as batchConfig } from './batch/view';
import { config as tableLoopConfig } from './table-loop/view';
import { config as tableLoop2Config } from './table-loop2/view';
import { config as tableReloadConfig } from './table-reload/view';
import { config as setFilterValueConfig } from './set-filter-value/view';
import { config as filterResetConfig } from './filter-reset/view';
import { config as filterSearchConfig } from './filter-search/view';
import { config as filterValidateConfig } from './filter-validate/view';
import { config as componentReloadConfig } from './component-reload/view';
import { config as componentReRenderConfig } from './component-rerender/view';
// eslint-disable-next-line import/no-cycle
import { config as pollingActionConfig } from './polling-action/view';
import { config as flowActionConfig } from './flow-action/view';
import { config as setStepActiveKeyConfig } from './set-step-active-key/view';
import { config as setTabActiveKeyConfig } from './set-tab-active-key/view';
import { config as tabReloadConfig } from './tab-reload/view';
import { config as loadDynamicFormConfigConfig } from './load-dynamic-form-config/view';
import { config as setTableSelectRowKeysConfig } from './set-table-select-row-keys/view';
import { config as setTableOpenKeysConfig } from './set-table-open-keys/view';
import { config as clearTableCurrentRowConfig } from './clear-table-current-row/view';
import { config as messageConfig } from './message/view';
import { config as confirmConfig } from './confirm/view';
import { config as dialogConfig } from './dialog/view';
import { config as closeDialogConfig } from './close-dialog/view';
import { config as textRenderConfig } from './text-render/view';
// eslint-disable-next-line import/no-cycle
import { config as submitConfig } from './submit/view';
import { config as downloadConfig } from './download/view';
import { config as exportButtonConfig } from './export/view';
import { config as requestConfig } from './request/view';
import { config as removeConfig } from './remove/view';
import { config as resetConfig } from './reset/view';
import { config as cancelConfig } from './cancel/view';
import { config as treeLoadConfig } from './tree-load/view';
import { config as waitConfig } from './wait/view';
import { config as arrayTableAddConfig } from './array-table/add/view';
import { config as arrayTableRemoveConfig } from './array-table/remove/view';
import { config as arrayTableMoveUpConfig } from './array-table/move-up/view';
import { config as arrayTableMoveDownConfig } from './array-table/move-down/view';
import { config as arrayTableCopyConfig } from './array-table/copy/view';
import { config as arraySubAreaCardAddConfig } from './array-sub-area-card/add/view';
import { config as arraySubAreaCardRemoveConfig } from './array-sub-area-card/remove/view';
import { config as arraySubAreaCardMoveUpConfig } from './array-sub-area-card/move-up/view';
import { config as arraySubAreaCardMoveDownConfig } from './array-sub-area-card/move-down/view';
import { config as arraySubAreaCardCopyConfig } from './array-sub-area-card/copy/view';
import { config as jsActionConfig } from './js-action/view';
import { config as setFormDataConfig } from './set-form-data/view';
import { config as setDataSourceValueConfig } from './set-data-source-value/view';
import { config as ossImportConfig } from './oss-import/view';
import { config as setSelectDataSourceConfig } from './set-select-data-source/view';
import { config as locationReloadConfig } from './location-reload/view';
import { config as nextStepConfig } from './next-step/view';
import { config as previousStepConfig } from './previous-step/view';
import { config as setFormStepCurrentConfig } from './set-form-step-current/view';
const componentMap = {
    link: linkConfig,
    request: requestConfig,
    remove: removeConfig,
    pollingAction: pollingActionConfig,
    batch: batchConfig,
    submit: submitConfig,
    reset: resetConfig,
    cancel: cancelConfig,
    dialog: dialogConfig,
    ossImport: ossImportConfig,
    export: exportButtonConfig,
    download: downloadConfig,
    tableReload: tableReloadConfig,
    jsAction: jsActionConfig,
    arrayTableRemove: arrayTableRemoveConfig,
    arrayTableAdd: arrayTableAddConfig,
    arrayTableMoveUp: arrayTableMoveUpConfig,
    arrayTableMoveDown: arrayTableMoveDownConfig,
    arraySubAreaCardRemove: arraySubAreaCardRemoveConfig,
    arraySubAreaCardAdd: arraySubAreaCardAddConfig,
    arraySubAreaCardMoveUp: arraySubAreaCardMoveUpConfig,
    arraySubAreaCardMoveDown: arraySubAreaCardMoveDownConfig,
    arraySubAreaCardCopy: arraySubAreaCardCopyConfig,
    componentReload: componentReloadConfig,
    message: messageConfig,
    confirm: confirmConfig,
    formReload: formReloadConfig,
    setFormData: setFormDataConfig,
    textRender: textRenderConfig,
    tableLoop: tableLoopConfig,
    setFormValue: setFormValueConfig,
    loadDynamicFormConfig: loadDynamicFormConfigConfig,
    filterReset: filterResetConfig,
    filterSearch: filterSearchConfig,
    filterValidate: filterValidateConfig,
    buttonGroup: buttonGroupConfig,
    setSelectDataSource: setSelectDataSourceConfig,
    closeDialog: closeDialogConfig,
    previousStep: previousStepConfig,
    nextStep: nextStepConfig,
    tabReload: tabReloadConfig,
    clearTableCurrentRow: clearTableCurrentRowConfig,
    setDataSourceValue: setDataSourceValueConfig,
    locationReload: locationReloadConfig,
    setTableSelectRowKeys: setTableSelectRowKeysConfig,
    setTableOpenKeys: setTableOpenKeysConfig,
    setTabActiveKey: setTabActiveKeyConfig,
    setStepActiveKey: setStepActiveKeyConfig,
    setFormStepCurrent: setFormStepCurrentConfig,
    treeReload: treeLoadConfig,
    wait: waitConfig,
    setFilterValue: setFilterValueConfig,
    tableLoop2: tableLoop2Config,
    formReRender: formRerenderConfig,
    setFormFieldState: setFormFieldStateConfig,
    componentReRender: componentReRenderConfig,
    flowAction: flowActionConfig,
    arrayTableCopy: arrayTableCopyConfig,
};
// 注册回调动作
export function registerButton(plugin) {
    const { name } = plugin || {};
    if (name) {
        componentMap[name] = plugin;
    }
}
/**
 * @description 获取对应position下动作的指定属性值
 * @param -position 位置；-componentName 动作名称；-propKey 属性key
 * @returns action执行函数
 */
export function getItem(position, componentName, propKey) {
    let result;
    if (componentName) {
        let item = componentMap[componentName];
        if (!item) {
            item = getBizComponent(componentName, position);
        }
        if (item?.position === ALL_BUTTON_POSITION_LIST ||
            item?.position?.includes?.(position)) {
            if (!item.label) {
                item.label = item.title;
            }
            if (!item.value) {
                item.value = item.componentName;
            }
            if (propKey) {
                result = item[propKey];
            }
            else {
                result = item;
            }
        }
    }
    return result;
}
/**
 * @description 获取某个动作的action执行函数
 * @param -optType 动作名称；-position 位置
 * @returns action执行函数
 */
export function getButtonAction(buttonConfig) {
    const { optType, position } = buttonConfig || {};
    if (optType) {
        const action = getItem(position, optType, 'action');
        if (typeof action === 'function') {
            return action;
        }
    }
}
/**
 * @description 获取运行时的动作配置
 * @param -componentName：动作名称
 * @returns 对应动作的配置信息
 */
export function getRunTimeItem(componentName) {
    let result;
    if (componentName) {
        result = componentMap[componentName];
        if (!result) {
            result = getRunTimeBizComponent(componentName);
        }
    }
    return result;
}
